import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { patchMethod } from "../../services/ApiCallMethods";

// PATCH: Update client active status
export const updateMfaStatus = createAsyncThunk(
  "user/updateMFAStatus",
  async ({ id, mfa_enabled }, { rejectWithValue }) => {
    try {
      const response = await patchMethod(`/api/users/${id}/mfa-status`, {
        mfa_enabled,
      });
      const data = await response.json();
      return data.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to update MFA status"
      );
    }
  }
);

const initialState = {
  isLoading: false,
  error: null,
  success: false,
  updatedUser: null,
};

const mfaStatusSlice = createSlice({
  name: "mfaStatus",
  initialState,
  reducers: {
    resetMfaStatus: (state) => {
      state.isLoading = false;
      state.error = null;
      state.success = false;
      state.updatedUser = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateMfaStatus.pending, (state) => {
        state.isLoading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(updateMfaStatus.fulfilled, (state, action) => {
        state.isLoading = false;
        state.success = true;
        state.updatedUser = action.payload;
      })
      .addCase(updateMfaStatus.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || "Something went wrong";
        state.success = false;
      });
  },
});

export const { resetMfaStatus } = mfaStatusSlice.actions;

export default mfaStatusSlice.reducer;

